import {
    RemoteData,
    getInitialData,
    setPage,
    setPagesToStale,
    setItem,
    markAllPagesOfAllEntriesAsStale
} from "../../../Models/Client/RemoteData"
import {
    BackofficeCustomerParams,
    Customer
} from "../../../Models/API/BackofficeModel"
import { Action, Reducer } from "redux"
import { BackofficeType } from "../../../Actions/Types"
import { RouterAction, LOCATION_CHANGE } from "connected-react-router"
import {
    APIAppInstanceModel,
    AppInstanceListParams
} from "../../../Models/API/AppInstanceModel"

export interface BackofficeState {
    customers: RemoteData<Customer, BackofficeCustomerParams, string>
    customerApps: {
        [username: string]:
            | RemoteData<APIAppInstanceModel, AppInstanceListParams, string>
            | undefined
    }
}

interface BackofficeSetCustomersAction
    extends Action<BackofficeType.setCustomers> {
    meta: {
        total: number
        page: number
        params: BackofficeCustomerParams
    }
    payload: Customer[]
}

interface BackofficeSetCustomerAction
    extends Action<BackofficeType.setCustomer> {
    meta: {
        username: string
    }
    payload: Customer
}

interface BackofficeSetCustomerAppsAction
    extends Action<BackofficeType.setCustomerApps> {
    meta: {
        username: string
        total: number
        page: number
        params: AppInstanceListParams
    }
    payload: APIAppInstanceModel[]
}

export type BackofficeAction =
    | BackofficeSetCustomersAction
    | BackofficeSetCustomerAction
    | BackofficeSetCustomerAppsAction

const initialState: BackofficeState = {
    customers: getInitialData(),
    customerApps: {}
}

const getCustomerId = (model: Customer) => model.username
const getAppId = (model: APIAppInstanceModel) => model.uuid

export const BackofficeReducer: Reducer<
    BackofficeState,
    BackofficeAction | RouterAction
> = (state = initialState, action): BackofficeState => {
    switch (action.type) {
        case LOCATION_CHANGE:
            return {
                ...state,
                customers: setPagesToStale(state.customers, 0),
                customerApps: markAllPagesOfAllEntriesAsStale(
                    state.customerApps
                )
            }
        case BackofficeType.setCustomers:
            return {
                ...state,
                customers: setPage(
                    state.customers,
                    action.meta.params,
                    action.payload,
                    getCustomerId,
                    action.meta.page,
                    action.meta.total
                )
            }
        case BackofficeType.setCustomer:
            return {
                ...state,
                customers: setItem(
                    state.customers,
                    action.meta.username,
                    action.payload,
                    getCustomerId
                )
            }

        case BackofficeType.setCustomerApps:
            return {
                ...state,
                customerApps: {
                    ...state.customerApps,
                    [action.meta.username]: setPage(
                        state.customerApps[action.meta.username] ??
                            getInitialData(),
                        action.meta.params,
                        action.payload,
                        getAppId,
                        action.meta.page,
                        action.meta.total
                    )
                }
            }

        default:
            return state
    }
}
